import { Box, Button, IconButton, InputAdornment, Stack, TextField } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { ReactNode } from "react";
import Iconify from "../../minimals/components/iconify";

type ReviewFieldHoverProps = { onMouseEnter: () => void; onMouseLeave: () => void };

interface PropertyLotsProps {
  sblError?: boolean;
  setLots: (lots: string[]) => void;
  lots: string[];
  lockedLots?: string[];
  isEditMode?: boolean;
  disabled?: boolean;
  renderReviewActions?: (fieldId: string, displayedValue: unknown) => ReactNode;
  getReviewFieldHoverProps?: (fieldId: string) => ReviewFieldHoverProps;
  getReviewFieldHighlightSx?: (fieldId: string) => SxProps<Theme>;
}

const PropertyLots = ({ setLots, lots = [], sblError, lockedLots, isEditMode, disabled, renderReviewActions, getReviewFieldHoverProps, getReviewFieldHighlightSx }: PropertyLotsProps) => {
  const isDisabled = Boolean(disabled);

  const handleLotChange = (value: string, index: number): void => {
    const newLots = [...lots];
    newLots[index] = value;
    setLots(newLots);
  };

  const addLot = (): void => {
    setLots([...lots, ""]);
  };

  const removeLot = (index: number): void => {
    const newLots = [...lots];
    newLots.splice(index, 1);
    setLots(newLots);
  };

  return (
    <Stack direction="column" spacing={2}>
      {lots?.map((lot, index) => (
        <Stack key={index} direction="row" alignItems="center" spacing={2}>
          <Box width="70%">
            <TextField
              label={`Lot ${lots.length > 1 ? index + 1 : ""}`}
              value={lot}
              {...getReviewFieldHoverProps?.(`propertyLot:${index}`)}
              sx={getReviewFieldHighlightSx?.(`propertyLot:${index}`)}
              onChange={(e) => handleLotChange(e.target.value, index)}
              error={index === 0 && sblError}
              fullWidth
              disabled={isDisabled || (isEditMode && Boolean(lockedLots?.[index]))}
              InputProps={{
                endAdornment: (
                  <>
                    {renderReviewActions && (
                      <InputAdornment position="end">{renderReviewActions(`propertyLot:${index}`, lot)}</InputAdornment>
                    )}
                    <IconButton
                      onClick={() => removeLot(index)}
                      aria-label="delete lot"
                      size="small"
                      disabled={isDisabled}
                      sx={{ visibility: lots.length > 1 && !isDisabled && !(isEditMode && Boolean(lockedLots?.[index])) ? "visible" : "hidden" }}
                    >
                      <Iconify icon={"eva:trash-2-outline"} />
                    </IconButton>
                  </>
                )
              }}
            />
          </Box>
          {lots.length - 1 == index && (
            <Button size="small" startIcon={<Iconify icon={"eva:plus-fill"} />} onClick={addLot} disabled={isDisabled}>
              Lot
            </Button>
          )}
        </Stack>
      ))}
    </Stack>
  );
};

export default PropertyLots;
